<template>
  <div v-if="test && test.questions">
    <div class="question mt-4" v-if="!isFinal">
      <div class="question__range-bg mt-1 mb-3">
        <div class="range" :style="{ width: calcRangeWidth + '%' }"></div>
      </div>
      <h1 class="pt-2">
        {{ currentQuestion.text }}
      </h1>
      <div class="question__answers pt-3">
        <div
          class="answer mb-2"
          style="width: 520px"
          v-for="(a, i) in currentQuestion.answers"
          :key="i"
        >
          <b-button
            @click="setSelectedAnswer(a, currentQuestion.descriptor)"
            class="text-start w-100 d-block"
          >
            <strong>{{ letters[i] }}</strong>
            {{ a.text }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="result text-center py-4" v-if="isFinal">
      <div class="result__header">
        <h1>Тест завершено</h1>
      </div>
      <div class="result__body">
        <h6>Ваш результат:</h6>
        <p class="mb-4 mt-2" v-html="result.text"></p>
        <div class="mb-4">
          <b-button :to="{ name: 'candidate-tests' }" variant="primary">
            До всіх тестів
          </b-button>
        </div>
        <div class="image py-4">
          <img width="300" src="@/assets/img/confirmed.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["test"],
  data() {
    return {
      isLoading: false,
      isFinal: false,
      //Answers
      answers: [],

      //Current test by type
      currentQuestionIndex: 0,
      letters: ["A", "B", "C", "D"],
      result: {},
    };
  },
  computed: {
    calcRangeWidth() {
      var percentage = 1;
      if (this.currentQuestionIndex != 0) {
        percentage =
          (this.currentQuestionIndex / this.test.questions.length) * 100;
      }

      if (this.currentQuestionIndex == this.test.questions.length - 1) {
        percentage = 98;
      }

      return percentage;
    },
    resultText() {
      let text = "Немає результату";
      return text;
    },
    totalScores() {
      let total = 0;
      for (var i = 0; i < this.answers.length; i++) {
        if (this.answers[i].a.length > 0) {
          let correct = this.answers[i].a[0].is_correct;
          if (correct) {
            total++;
          }
        }
      }
      return total;
    },
    currentQuestion() {
      let question;
      if (this.test.questions && this.test.questions.length) {
        question = this.test.questions[this.currentQuestionIndex];
      }
      return question;
    },
  },
  methods: {
    async fetchTest() {
      this.isLoading = true;
      let args = {
        collectionName: "tests",
        where: ["id", "==", Number(this.$route.params.id)],
      };
      let result = await this.$db.getCollection(args);
      this.test = result.docs[0];
      // for (var i = 0; i < this.test.questions.length; i++) {
      //   var q = this.test.questions[i];
      //   this.answers.push({
      //     q: q.text,
      //     a: [],
      //   });
      // }
      this.isLoading = false;
    },
    setSelectedAnswer(a, d) {
      console.log(a, d);
      let res = {
        descriptor: d,
        points: a.points,
        type: a.type,
      };

      let d_index = this.answers.findIndex((el) => {
        return el.id == res.descriptor;
      });
      let t_index = this.answers[d_index].types.findIndex((el) => {
        return el.key == res.type;
      });

      console.log(a.type, d_index, t_index, this.answers[d_index].types);
      if (d_index > -1 && t_index > -1) {
        this.answers[d_index].types[t_index].points += res.points;
      }

      if (this.currentQuestionIndex + 1 < this.test.questions.length) {
        this.currentQuestionIndex++;
      } else {
        this.isFinal = true;

        let result_text = "";

        this.answers.forEach((el) => {
          result_text += `<strong>${el.name}</strong>: `;
          el.types.forEach((t) => {
            result_text += `${t.key} - ${t.points} балів,`;
          });
        });

        let results = {
          answers: this.answers,
          text: result_text,
        };
        this.result = results;
        this.$emit("finish", results);
      }
    },
    mapAnswers() {
      this.answers = [];
      for (var i = 0; i < this.test.descriptors.length; i++) {
        var d = this.test.descriptors[i];
        let a_item = {
          id: d.id,
          name: d.name,
          types: [],
        };
        this.test.descriptors[i].types.forEach((el) => {
          a_item.types.push({
            key: el,
            points: 0,
          });
        });

        this.answers.push(a_item);
      }
    },
  },
  mounted() {
    this.mapAnswers();
  },
};
</script>

<style lang="scss" scoped>
.result {
  &__header {
    h1 {
      color: rgb(0, 128, 49);
    }
  }
}
.question {
  &__range-bg {
    background-color: #999;
    position: relative;
    height: 4px;
    .range {
      min-width: 5px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      background: var(--secondary-color);
      transition: 0.8s;
      max-width: 100%;
    }
  }
  &__answers {
    width: 540px;
    max-width: 100%;
    .answer {
      .btn {
        padding-left: 36px !important;
        position: relative;
        background: var(--primary-color);
        border: none !important;
        strong {
          margin-right: 10px;
          opacity: 1;
          position: absolute;
          left: 10px;
          color: var(--secondary-color) !important;
        }
        &:active {
          background: var(--secondary-color) !important;
          color: var(--primary-color) !important;
          strong {
            color: var(--primary-color) !important;
          }
        }
      }
    }
  }
}
</style>
